import React from "react";
import { Box, CardContent } from "@mui/material";
import { Link } from "react-router-dom";
import {
  FaBookOpen,
  FaPenNib,
  FaHeadphones,
  FaLightbulb,
} from "react-icons/fa";
const lessonIcons = [
  <FaBookOpen />,
  <FaPenNib />,
  <FaHeadphones />,
  <FaLightbulb />,
];
const LessonCard = ({ lesson }) => {
  const visualIndex = lesson.id.length % 4;
  return (
    <Box className="lesson-card">
      {" "}
      {/* Lesson Visual */}{" "}
      <div className={`lesson-visual visual-${visualIndex}`}>
        {" "}
        <div className="lesson-visual-top">
          {" "}
          <span className="lesson-brand">PureEng</span>{" "}
          <span className="lesson-number">
            {" "}
            {String(lesson.id).padStart(2, "0")}{" "}
          </span>{" "}
        </div>{" "}
        <div className="lesson-icon"> {lessonIcons[visualIndex]} </div>{" "}
        <div className="lesson-visual-bottom">
          {" "}
          <span>ENGLISH</span> <strong>LESSON</strong>{" "}
        </div>{" "}
      </div>{" "}
      {/* Content */}{" "}
      <CardContent className="lesson-content">
        {" "}
        <span className="lesson-badge"> English Lesson </span>{" "}
        <h3 className="lesson-title"> {lesson.title} </h3>{" "}
        <p className="lesson-description">
          {" "}
          {lesson.description ||
            "استكشف الدرس وابدأ التعلم بطريقة سهلة ومبسطة مع PureEng."}{" "}
        </p>{" "}
        <Link
          className={`lesson-button ${lesson.hasAccess ? "start" : "enroll"}`}
          to={`/lessons/details/${lesson.id}`}
        >
          {" "}
          {lesson.hasAccess ? "ابدأ الدرس ←" : "اشترك الآن ←"}{" "}
        </Link>{" "}
      </CardContent>{" "}
    </Box>
  );
};
export default LessonCard;
